import { axios } from '@/utils/request'
const api = {
  Pre: '/admin.php/Tenant/pre',
  TenantList: '/admin.php/Tenant/getList',
  TenantDetail: '/admin.php/Tenant/tenantDetail',
  TenantDeviceList: '/admin.php/Tenant/tenantDeviceList',
  DeviceForbidden: '/admin.php/Tenant/tenantDeviceForbidden',
  AddTenant: '/admin.php/Tenant/add',
  SaveTenant: 'admin.php/Tenant/edit',
  TenantForbidden: '/admin.php/Tenant/tenantForbidden',
  TenantExpiryTimeSave: '/admin.php/Tenant/tenantExpiryTime',
  SqlDetail: '/admin.php/Sqlversion/detail',
  SyncDatabase: '/admin.php/Tenant/syncDatabase',
  ConfigSetting: '/admin.php/Tenant/configSetting',
  addAnnualOrder: '/admin.php/order/addAnnualOrder',
  annualPay: '/admin.php/order/pay',
  orderPre: '/admin.php/order/pre',
  queryPayResult: '/admin.php/order/queryPayResult',
  getMerchantUrl: '/admin.php/tenant/getMerchantUrl',
  editMemberTermUrl: '/admin.php/tenant/editMemberTerm'
}

// 创建年费订单
export function addAnnualOrder (parameter) {
  return axios({
    url: api.addAnnualOrder,
    method: 'post',
    data: parameter
  })
}
// 调起支付
export function annualPay (parameter) {
  return axios({
    url: api.annualPay,
    method: 'post',
    data: parameter
  })
}

// 订单预加载
export function orderPre (parameter) {
  return axios({
    url: api.orderPre,
    method: 'get',
    params: parameter
  })
}

// 预加载
export function getPre () {
  return axios({
    url: api.Pre,
    method: 'get'
  })
}

export function getTenantList (parameter) {
  return axios({
    url: api.TenantList,
    method: 'get',
    params: parameter
  })
}

export function getTenantDetail (parameter) {
  return axios({
    url: api.TenantDetail,
    method: 'get',
    params: {
      tenant_id: parameter
    }
  })
}

export function getTenantDeviceList (parameter) {
  return axios({
    url: api.TenantDeviceList,
    method: 'get',
    params: parameter
  })
}

export function addTenant (parameter) {
  return axios({
    url: api.AddTenant,
    method: 'post',
    data: parameter
  })
}

export function postUpdateTenant (parameter) {
  return axios({
    url: api.SaveTenant,
    method: 'post',
    data: parameter
  })
}

export function deviceForbidden (parameter) {
  return axios({
    url: api.DeviceForbidden,
    method: 'post',
    data: parameter
  })
}

export function tenantForbidden (parameter) {
  return axios({
    url: api.TenantForbidden,
    method: 'post',
    data: parameter
  })
}

export function tenantExpiryTimeSave (parameter) {
  return axios({
    url: api.TenantExpiryTimeSave,
    method: 'post',
    data: parameter
  })
}

export function syncDatabase (parameter) {
  return axios({
    url: api.SyncDatabase,
    method: 'post',
    data: parameter
  })
}

export function getSqlInfo (parameter) {
  return axios({
    url: api.SqlDetail,
    method: 'get',
    params: parameter
  })
}

export function configSetting (parameter) {
  return axios({
    url: api.ConfigSetting,
    method: 'post',
    data: parameter
  })
}
// 查询订单支付状态
export function queryPayResult (parameter) {
  return axios({
    url: api.queryPayResult,
    method: 'post',
    data: parameter
  })
}
// 获取后台地址
export function getMerchantUrl (parameter) {
  return axios({
    url: api.getMerchantUrl,
    method: 'get',
    params: parameter
  })
}
// 修改商家使用期限
export function editMemberTerm (parameter) {
  return axios({
    url: api.editMemberTermUrl,
    method: 'post',
    params: parameter
  })
}
